import { ctApi } from '@/api';
import { categoriesByQuery, CategoryData } from '@/graphql/categoryQuery';

export const categoriesByKeys = async (keys: string[]): Promise<CategoryData[]> => {
  const response = await ctApi
    .graphql()
    .post({
      body: {
        query: categoriesByQuery,
        variables: {
          query: `key in ("${keys.join('","')}") and custom(fields(hidden = false))`,
          locale: 'en',
          limit: 50,
        },
      },
    })
    .execute();
  return response.body.data.categories.results;
};
